module.exports = __webpack_public_path__ + "static/octupus-3-cf34a17694cbc5c847978b7be77e4425.jpg";